import * as N from './N'
import * as R from './R'
import * as K from './K'
import * as G from './G'
import * as H from './H'
import * as Q from './Q'

export const RulesByModelCode = {
  N,
  R,
  K,
  G,
  H,
  Q,
}
